import { ResponseError } from 'pco-product-service-internal-consumer';

export const getErrorDetailsForCause = async (error: unknown): Promise<string> => {
  if (error instanceof ResponseError) {
    const response = error.response;
    const contentType = response.headers.get('content-type') ?? '';
    const responseText = await response.clone().text();
    let responseBody = responseText;

    if (contentType.includes('json') && responseText) {
      try {
        responseBody = JSON.stringify(JSON.parse(responseText), null, 2);
      } catch {
        responseBody = responseText;
      }
    }

    return [
      `status: ${response.status}`,
      `statusText: ${response.statusText || '-'}`,
      `url: ${response.url || '-'}`,
      `body: ${responseBody || '-'}`,
    ].join('\n');
  }

  if (error instanceof Error) {
    return [`name: ${error.name}`, `message: ${error.message}`].join('\n');
  }

  return `message: ${String(error)}`;
};
